/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const BookDown = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M12 13V7" }],
    [
      "path",
      {
        d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"
      }
    ],
    ["path", { d: "m9 10 3 3 3-3" }]
  ]
];

export { BookDown as default };
//# sourceMappingURL=book-down.js.map
